import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordValidator(showErrorMessage?: boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null; // pas d'erreur si vide, required gère ça
    }

    const minLength = value.length >= 10;
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumberOrSpecial = /[0-9!@#$%^&*()_+\-=[\]{}:;'"<>.,?/\\|~]/.test(
      value
    );

    const valid =
      minLength && hasUpperCase && hasLowerCase && hasNumberOrSpecial;
    let showMessage = true;
    if (showErrorMessage === false) {
      showMessage = false;
    }
    return valid ? null : { passwordStrength: showMessage };
  };
}
